import React, { useMemo } from 'react';
import { useApplyLeave } from '../context/ApplyLeaveContext';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';

import noRecordFound from "../../../assets/images/empty-folder.png";
import "./leaveList.scss";
import 'swiper/css';
import 'swiper/css/pagination';

import { useIsMobile } from '../../../hooks/commonHooks';


const styleMap = {
  'Casual Leave': { bg: 'casualLeaveBg', text: 'casualLeaveText' },
  'Sick Leave': { bg: 'sickLeaveBg', text: 'sickLeaveText' },
  'Earned Leave': { bg: 'earnedLeaveBg', text: 'earnedLeaveText' },
  'Permission': { bg: 'permissionLeaveBg', text: 'permissionLeaveText' }
};

const getStyles = (policyName: string | undefined) =>
  styleMap[policyName as keyof typeof styleMap] ||
  { bg: 'casualLeaveBg', text: 'earnedLeaveText' };

const LeaveCard = ({ policyName, balance }: { policyName: string | undefined, balance: number }) => {
  const { bg, text } = getStyles(policyName);
  return (
    <div className={`flex items-center justify-between ${bg} rounded-xl p-4 text-[16px] font-normal`}>
      <p>{policyName}</p>
      <p className={`text-[28px] ${text} font-medium`}>{balance}</p>
    </div>
  );
};

const LeaveList = () => {
  const { leaveBankData, loader } = useApplyLeave();
  const isMobile = useIsMobile();

  const filteredLeaveData = useMemo(() =>
    leaveBankData?.filter(item => item.policyName !== "Permission" && item.policyName !== 'On Duty') || [],
    [leaveBankData]
  );

  if (!filteredLeaveData.length) {
    return (
      <div className="no-record leave-list flex justify-center h-full">
        <p className='flex justify-center items-center text-xl'>
          <img src={noRecordFound} alt="No Record Found" />
        </p>
      </div>
    );
  }

  return (
    <div className={`space-y-5 w-[100%] mb-2 md:mb-4 lg:mb-0 pt-1 md:pt-[20px] pl-[10px] pr-[5px] lg:min-h-[40vh]`}>
      {isMobile ? (
        <Swiper
          modules={[Pagination]}
          spaceBetween={20}
          slidesPerView={1}
          pagination={{ clickable: true }}
          breakpoints={{
            550: { slidesPerView: 2 },
            1024: { slidesPerView: 3 }
          }}
        >
          {filteredLeaveData.map((item, index) => (
            <SwiperSlide key={index}>
              <LeaveCard policyName={item.policyName} balance={item.balance} />
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <>
          {filteredLeaveData.map((item, index) => (
            <LeaveCard key={index} policyName={item.policyName} balance={item.balance} />
          ))}
        </>
      )}

      {/* {loader && <Loader />} */}
    </div>
  );
};

export default LeaveList;
